<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>
    <form [formGroup]="form" (submit)="null">
      <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">

        <div class="rows scrollable-section" #scrollableSection>
          <div class="col-sm-12 col-lg-12 ">
            <div class="row justify-content-center">
              <div class="col-xl-6 ">
                <div class="block">
                  <app-dropdown-formularios dataSize="7" placeHolder="Empresas"
                    [selectedValue]="form.get('company').value || ''"
                    (selectedValueChange)="companySelectedChanged($event)" [required]="true"
                    [dropdownType]="'Companies'" [multiple]="true">
                  </app-dropdown-formularios>



                  <app-form-input-app [labelText]="'Título del anuncio'" [isRequired]="true">
                    <input formControlName="title" class="form-control mb-1" autocomplete="off" type="text"
                      name="title">
                  </app-form-input-app>

                  <div class="mt-3 pt-2 d-flex justify-content-center flex-column ">
                    <label class="col-md-14 azul-a3Factura mb-1 mt-2 dx-field-item-required">Contenido <span
                        class="star ng-star-inserted">*</span></label>
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor formControlName="editorContent" [editor]="editor" [placeholder]="'Escribe aquí'"
                      class="custom-editor"></ngx-editor>
                  </div>
                </div>
              </div>

              <div class="col-6 ">
                <div class="block">
                  <app-form-input-app [labelText]="'Estado'" [isRequired]="false">
                    <input formControlName="state" class="form-control mb-1" autocomplete="off" type="text" name="state"
                      readonly>
                  </app-form-input-app>
                  <app-form-input-app [labelText]="'Publicador'" [isRequired]="false">
                    <input formControlName="modifiedBy" class="form-control mb-1" autocomplete="off" type="text"
                      name="modifiedBy" readonly>
                  </app-form-input-app>
                  <app-form-input-app [labelText]="'Fecha de publicación'" [isRequired]="false">
                    <input formControlName="publishedOn" class="form-control mb-1" autocomplete="off" type="text"
                      name="publishedOn" readonly>
                  </app-form-input-app>
                  <app-form-input-app [labelText]="'Fecha de última modificación'" [isRequired]="false">
                    <input formControlName="modifiedOn" class="form-control mb-1" autocomplete="off" type="text"
                      name="modifiedOn" readonly>
                  </app-form-input-app>
                </div>

              </div>

            </div>

            <div class="row justify-content-center" *ngIf="data?.userViews?.length">
              <div class="col-12">
                <legend class="pl-3 mt-5">Visualizado por</legend>
                <dx-data-grid id="gridContainer" [dataSource]="this.data.userViews">
                  <dxi-column dataField="userName" caption="Nombre"></dxi-column>
                  <dxi-column dataField="companyData.name" caption="Empresa"></dxi-column>
                  <dxi-column dataField="viewedAt" caption="Fecha visualizacion" dataType="date"
                    format="dd/MM/yyyy"></dxi-column>
                  <dxo-export [enabled]="true" [fileName]="'Listado_Visualizaciones_Anuncio'"></dxo-export>
                </dx-data-grid>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="ml-auto mr-3">
            <div class="form-group form-button">
              <div class="btn-group float-right">

                <button class="btn btn-fill btn-success float-right" (click)="saveAndPublishData()">Guardar y
                  publicar</button>
                <button type="button" class="btn btn-success dropdown-toggle options-button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item btn btn-fill btn-success" style="color:white"
                    (click)="publishData(this.announcement1)">Publicar</a>
                  <a class="dropdown-item btn btn-fill btn-disabled" style="color:white; background-color: #70ca73;"
                    (click)="saveData()">Guardar</a>
                </div>
              </div>
              <a class="btn btn-fill btn-danger float-right ">Volver</a>
            </div>
          </div>
        </div>
      </app-generic-panel>
    </form>
  </div>



</div>